import React, { useCallback } from 'react';
import { useRouter } from 'expo-router';
import { defineMessages, useIntl } from 'react-intl';

import { NotFoundView } from '../../..';
import { useResetLastInteractedMenuStore } from '../../../../context/LastInteractedStore';

// ─────────────────────────────────────────────────────────────────────────────

export const MenuContentError = () => {
  const router = useRouter();
  const { formatMessage } = useIntl();

  const resetLastInteractedMenuStore = useResetLastInteractedMenuStore();

  // ─── Helpers ─────────────────────────────────────────────────────────

  const changeLocation = useCallback(() => {
    router.navigate('/locations');
  }, [router]);

  // ─────────────────────────────────────────────────────────────────────

  return (
    <NotFoundView
      btnLabel={formatMessage(messages.ctaLabel)}
      onBtnPress={changeLocation}
      onMount={resetLastInteractedMenuStore}
    />
  );
};

// ─── Messages ────────────────────────────────────────────────────────────────

const messages = defineMessages({
  ctaLabel: {
    defaultMessage: 'Select another location',
    description: 'Menu | Error | Heading',
  },
});
